export default "__VITE_ASSET__hL5Mardm__"